if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.mainGallery = this.querySelector('[id^="MediaArea"]');
        this.thumbnails = document.querySelector('[id="Thumbnails"]');
        this.thumbnails_Mobile = document.querySelector('[id="gallery-thumb-mobile"]');
        this.mainSwiper = null;
        this.thumbnailSwiper = null
        this.thumbnailSwiperMobile = null
      }

      connectedCallback() {
        // Mobile thumbnail swiper
        this.thumbnailSwiperMobile = new Swiper(this.thumbnails_Mobile, {
          spaceBetween: 7,
          watchSlidesProgress: true,
          breakpoints: {
            0: {
              slidesPerView: 4,
            },
            768: {
              slidesPerView: 8,
            },
            1025: {
              slidesPerView: 'auto',
            }
          }
        });

        // Desktop thumbnail swiper
        this.thumbnailSwiper = new Swiper(this.thumbnails, {
          slidesPerView: 'auto',
          spaceBetween: 7,
          breakpoints: {
            0: {
            navigation: {
              enabled: this.dataset.size > 4 ? true : false,

              nextEl: document.querySelector('.desk-thumbnail-gallery .swiper-button-next'),
              prevEl: document.querySelector('.desk-thumbnail-gallery .swiper-button-prev')
            }
          },
          1400: {
            navigation: {
              enabled: this.dataset.size > 5 ? true : false,

              nextEl: document.querySelector('.desk-thumbnail-gallery .swiper-button-next'),
              prevEl: document.querySelector('.desk-thumbnail-gallery .swiper-button-prev')
            }
          }
          }
        });

        // Media query for mobile/desktop switching
        const mediaQuery = window.matchMedia('(max-width: 1024px)');

        // Function to get the active thumbnail swiper
        const getActiveThumbSwiper = () => mediaQuery.matches ? this.thumbnailSwiperMobile : this.thumbnailSwiper;

        // Main swiper
        this.mainSwiper = new Swiper(this.mainGallery, {
          slidesPerView: 1,
          breakpoints: {
            0: {
              navigation: {
                enabled: this.dataset.size > 4 ? true : false,
                nextEl: this.querySelector('.thumbanil-gallery-mobile .swiper-button-next'),
                prevEl: this.querySelector('.thumbanil-gallery-mobile .swiper-button-prev'),
              }
            },
            769: {
              navigation: {
                enabled: this.dataset.size > 8 ? true : false,
                nextEl: this.querySelector('.thumbanil-gallery-mobile .swiper-button-next'),
                prevEl: this.querySelector('.thumbanil-gallery-mobile .swiper-button-prev'),
              }
            },
            1025: {
              navigation: {
                  nextEl: this.mainGallery.querySelector('.swiper-button-next'),
                  prevEl: this.mainGallery.querySelector('.swiper-button-prev'),
                }
              }
            },
          on: {
            afterInit: function (el) {
              var currentSlide = el.slides[el.activeIndex];
                var currentImage = currentSlide.querySelector('img');
                if (currentImage.complete) {
                  updateGalleryDimensions(currentImage);
                } else {
                  currentImage.addEventListener('load', function () {
                    updateGalleryDimensions(currentImage);
                  });
                }
            }
          },
          thumbs: {
            swiper: getActiveThumbSwiper(),
          }
          
        });
        function updateGalleryDimensions(image) {
          var w = image.offsetWidth;
          var h = image.offsetHeight;
        
          document.querySelector('.product-main-gallery-icons .icon-wrapper').style.setProperty('--width', w + 'px');
          document.querySelector('.product-main-gallery-icons').style.setProperty('--height', h + 'px');
        }
        // Function to sync swipers
        const syncSwipers = () => {
          this.mainSwiper.on("slideChange", () => {
            const activeThumbSwiper = getActiveThumbSwiper();
            activeThumbSwiper.slideTo(this.mainSwiper.activeIndex);
          });

          [this.thumbnailSwiperMobile, this.thumbnailSwiper].forEach(thumbSwiper => {
            thumbSwiper.on("slideChange", () => {
              this.mainSwiper.slideTo(thumbSwiper.activeIndex);
            });
          });
        };
        syncSwipers();
      }

      setActiveMedia(mediaId) {
        if (!mediaId) {
          return;
        }
        console.log(this.mainGallery.querySelector(`[data-media-id="${mediaId}"]`))
        const activeVariant = parseInt(this.mainGallery.querySelector(`[data-media-id="${mediaId}"]`).dataset.index);
        this.mainSwiper.slideTo(activeVariant);
        this.thumbnailSwiper.slideTo(activeVariant);
      }
    }
  );
}